import { Component, ComponentFactory, OnDestroy, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { CardsService } from "../cards.service";
import { UserService } from "@app/core/user.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { User } from "@app/shared/user";
import { ComponentType } from "@app/component-type";
import { AnalyticsService } from "@app/core/analytics.service";
import { enterAnimation } from "@app/shared/page-state/animations";
import { HomePageAnalyticsService } from "@app/home/home-page-analytics.service";

@Component({
  selector: "om-home-page",
  templateUrl: "./home-page.component.html",
  styleUrls: ["./home-page.component.scss"],
  animations: [enterAnimation],
})
export class HomePageComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject();
  user: User;
  cardRows: ComponentFactory<ComponentType>[][];

  constructor(
    private title: Title,
    private cardsService: CardsService,
    private userService: UserService,
    private analyticsService: AnalyticsService,
    private homePageAnalyticsService: HomePageAnalyticsService
  ) {}

  ngOnInit() {
    this.title.setTitle("Home");

    this.userService.user$
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => (this.user = user));
    this.userService.getUser();

    this.cardsService.cards$
      .pipe(takeUntil(this.destroy$))
      .subscribe(cards => (this.cardRows = cards));
    this.cardsService.getCards();

    this.analyticsService.setModule(this.homePageAnalyticsService.getModule());
    this.homePageAnalyticsService.trackHomePageViewed();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
